// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__IuZ_j","upload":"Small_upload__3ZpbP","imageWrap":"Small_imageWrap__2j3zn","removeBtn":"Small_removeBtn__3h30a"};